import { OptimisationBase } from '@/optimizer';
import { formatNumber } from '@/utils/numberUtils';

export const formatCampaignTargetValue = (
    optimizationBase: OptimisationBase,
    value: number,
    contributionFormatter: (value: number) => string,
    currency = 'EUR',
    locale = 'fi-FI',
): string =>
    optimizationBase === 'budget'
        ? `${formatNumber(value, locale)} ${currency}`
        : contributionFormatter(value);
